import { Box, List } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { axiosInstance } from 'src/api/axios';
import Menuitems from './AdminMenuItems';
import NavGroup from './NavGroup/NavGroup';
import NavItem from './NavItem';

const SidebarItems = () => {
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const [permissions, setPermissions] = useState({});
  const [userRight, setUserRights] = useState([]);
  useEffect(()=>{
      
        if(!permissions.length){
        axiosInstance.get('/misc/allowed_features')
        .then((res)=>{
            const {roleMapping, userRights} = res.data;
            setPermissions({...roleMapping});
            setUserRights(userRights);
        })
        .catch((err)=>{
            console.error("Error fetching allowed features:", err);
        });
      }
  },[])
  
  // File Jobs surfaces report/transaction/lead export jobs, so only show it to
  // admins who can view at least one of those job types.
  const fileJobsPerms = ['view_reports', 'manage_referrals', 'create_reports', 'view_transactions', 'view_leads'];

  const filterItems = () =>{
    const filteredItems = Object.keys(permissions).length && Menuitems.filter((item)=>{
          // {/********Permission Check**********/}
          if(item?.title){
              if(item.title === 'File Jobs'){
                return userRight.some((right) => fileJobsPerms.includes(right));
              }
              if(!Object.keys(permissions).includes(item.title)){
                return true
              }
            if(permissions[item.title]){
              let itemPermission = new Set(permissions[item.title]);
              let hasAccess = userRight.some(right => itemPermission.has(right));
              
              return hasAccess;
          }
        }
        return true;
        })
    if(filteredItems.length){
      return filteredItems;
    }else{
      return [Menuitems[0], Menuitems[1], Menuitems[Menuitems.length -2] , Menuitems[Menuitems.length -1]]
    }
  }

  return (
    <Box sx={{ px: 3 }}>
      <List sx={{ pt: 0 }} className="sidebarNav">
        {
          filterItems().map((item) => {
          // {/********SubHeader**********/}
          if (item.subheader) {
            return <NavGroup item={item} key={item.subheader} />;

            // {/********If Sub Menu**********/}
            /* eslint no-else-return: "off" */
          } else {
            return (
              <NavItem item={item} key={item.id} pathDirect={pathDirect} />
            );
          }
        })}
      </List>
    </Box>
  );
};
export default SidebarItems;
